<template>
  <group-card
    title="Request Documents"
    icon="attachment"
    :loading="sending_email"
  >
    <md-tabs v-if="applicants" md-dynamic-height>
      <md-tab
        v-for="(applicantObj, index) in applicants"
        :md-label="'Applicant ' + (index + 1)"
        :key="String(applicantObj.id)"
        :id="String(applicantObj.id)"
      >
        <document-requests-component v-model="applicants[index]" :application="application" @loading="loading"></document-requests-component>
      </md-tab>
    </md-tabs>

  </group-card>
</template>

<script>
import { mapGetters } from "vuex";
import DocumentRequestsComponent from '@/components/Document/DocumentRequestsComponent';
import GroupCard from "@/components/Cards/GroupCard";

export default {
  data() {
    return {
      sending_email: false,
    };
  },
  components: {
    GroupCard,
    DocumentRequestsComponent
  },

  computed: {
    ...mapGetters(["application", "application_status"]),

    applicants() {
      if (this.application_status.loaded) {
        return this.application.applicants;
      }
      return;
    },

  },

  methods: {
    loading(value) {
      this.sending_email = value;
    },
  },
  
};
</script>